module.exports = __webpack_public_path__ + "static/baileykevinpoohwithholyriders-e83c7959420dbedf99b2d1a121801883.jpg";